import { ModalBody, ModalHeader } from '@chakra-ui/react';
import { GradientText } from '@ui/components/GradientText/GradientText';
import { useTranslations } from 'next-intl';

import { SearchInput } from './SearchInput';
import { TokenList } from './TokenList';

export const DefaultContent = () => {
  const t = useTranslations();
  return (
    <>
      <ModalHeader flexDirection="column">
        <GradientText gradient="gradients.white-blue-title">
          {t('card.select token')}
        </GradientText>
        <SearchInput mt="16px" />
      </ModalHeader>
      <ModalBody className="no-scrollbar" pt="0px">
        <TokenList />
      </ModalBody>
    </>
  );
};
